import ProductEntity from "@modules/products/entities/ProductEntity";

import { ProductSdkDto } from "../types";
import { mapProductImageToSdkDto } from "./mapProductImageToSdkDto";

export function mapProductToSdkDto(product: ProductEntity): ProductSdkDto {
    return {
        id: product.id,
        title: product.title,
        handle: product.handle,
        images: product.images.map(mapProductImageToSdkDto),
    };
}
